<template>
  <div class="bg-settings" v-if="!isTokenAvailable">
    <b-container class="bg-settings mt-4">
      <b-row>
        <b-col cols="12" class="d-flex align-items-center">
          <div class="p2">
            <b-button @click="redirectToFacebookOAuth" class="alert-button-desktop" type="button" variant="orange" size="md"
                >Login com Facebook</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <div class="bg-settings" v-else>
    <b-container class="bg-settings mt-4">
      <b-row>
        <b-col cols="12" class="d-flex align-items-center justify-content-between">
          <div>
            <span class="page-title">Social Media Insights - {{ instagramProfile && instagramProfile.name }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col md="6">
          <b-card class="profile-card mb-3">
            <div class="d-flex align-items-center">
              <b-img
                src="@/assets/images/facebook_logo.png"
                class="mr-3"
                rounded
                width="64"
                height="64"
                alt="Facebook Page" />
              <div>
                <div class="font-weight-bold">
                  <b-link v-if="instagramPages.length && instagramPages[0].link && instagramPages[0].name" :href="instagramPages[0].link" target="_blank">
                    <span>{{ instagramPages.length && instagramPages[0].name }}</span>
                  </b-link>
                </div>
                <div class="small text-muted"> <span class="font-weight-bold">Categoria:</span> {{ instagramPages.length && instagramPages[0].category }}</div>
                <div class="small text-muted"> <span class="font-weight-bold">Bio:</span> {{ instagramPages.length && instagramPages[0].about }}</div>
                <div class="small text-muted"> <span class="font-weight-bold">Curtidas na Página:</span> {{ instagramPages.length && instagramPages[0].followers_count }}</div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="6">
          <b-card class="profile-card mb-3">
            <div class="d-flex align-items-center">
              <b-img
                src="@/assets/images/instagram_logo.png"
                class="mr-3"
                rounded
                width="64"
                height="64"
                alt="Instagram Profile" />
              <div>
                <div class="font-weight-bold">
                  <b-link v-if="instagramProfile && instagramProfile.username" :href="`https://www.instagram.com/${instagramProfile.username}`" target="_blank">
                    <span>@{{ instagramProfile && instagramProfile.username }}</span>
                  </b-link>
                </div>
                <div class="small text-muted"> <span class="font-weight-bold">ID:</span> {{ instagramProfile && instagramProfile.id }}</div>
                <div class="small text-muted"> <span class="font-weight-bold">Seguidores:</span> {{ instagramProfile && instagramProfile.followers_count }}</div>
                <div class="small text-muted"> <span class="font-weight-bold">Posts:</span> {{ instagramProfile && instagramProfile.media_count }}</div>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <b-tabs card justified nav-class="custom-tabs" content-class="custom-tab-content">
            <b-tab title="INSTAGRAM INSIGHTS">
              <b-card class="tab-card">
                <div class="font-weight-bold mb-2">Desempenho da Conta:</div>
                <b-list-group flush>
                  <b-list-group-item> Alcance (28 dias): <span class="font-weight-bold">{{ instagramProfile && instagramProfile.insights && instagramProfile.insights.reach_28_days }}</span></b-list-group-item>
                  <b-list-group-item> Impressões (24 horas): <span class="font-weight-bold">{{ instagramProfile && instagramProfile.insights && instagramProfile.insights.impressions_24_hours }}</span></b-list-group-item>
                  <b-list-group-item> Engajamento (24 horas): <span class="font-weight-bold">{{ instagramProfile && instagramProfile.insights && instagramProfile.insights.engagement_24_hours }}</span></b-list-group-item>
                  <b-list-group-item> Novos Seguidores (24 horas): <span class="font-weight-bold">{{ instagramProfile && instagramProfile.insights && instagramProfile.insights.new_followers_24_hours }}</span></b-list-group-item>
                </b-list-group>
                <div class="font-weight-bold mt-4 mb-2">Conteúdo em Destaque:</div>
                <b-list-group>
                  <b-list-group-item>
                     Posts com Mais Curtidas:
                    <ul class="recent-list mt-2">
                      <li v-for="post in instagramLikedPosts" :key="post.id"> "{{ post.caption.slice(0,50) }}..." - Curtidas: {{ post.like_count }}, Salvos: {{ post.insights.saved }}</li>
                    </ul>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-tab>
            <b-tab title="CONTEÚDO RECENTE">
              <b-card class="tab-card">
                <div class="font-weight-bold mb-2">Post Mais Recente(Instagram):</div>
                <b-list-group>
                  <b-list-group-item class="preserve-lines" v-for="post in instagramPosts" :key="post.id">
                    <div v-if="post.media_url">
                      <b-img :src="post.media_url" fluid />
                    </div>
                    {{ post.caption }}
                  </b-list-group-item>
                </b-list-group>
                <div class="font-weight-bold mt-4 mb-2">Insights Recentes:</div>
                <b-list-group>
                  <b-list-group-item v-for="post in instagramPosts" :key="post.id">
                     Impressões: <span class="font-weight-bold">{{ post.insights && post.insights.views }}</span><br>
                     Alcance: <span class="font-weight-bold">{{ post.insights && post.insights.reach }}</span><br>
                     Curtidas: <span class="font-weight-bold">{{ post.like_count }}</span>
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <div class="text-muted small">
            Dados atualizados em 27/05/2025.
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'SocialMediaInsights',
  computed: {
    ...mapGetters([
      'instagramPages',
      'instagramMetadata',
      'instagramPosts',
      'instagramLikedPosts',
      'instagramProfile',
      'fbAccessToken',
    ]),
    isTokenAvailable() {
      return this.fbAccessToken !== null && this.fbAccessToken !== undefined;
    },
  },
  methods: {
    ...mapActions(['loadInsightsData', 'persistAccessToken']),
    redirectToFacebookOAuth() {
      const appId = '1252413999402529';
      const redirectUri = 'https://afiliados.uol.com.br/app/social-media-insights';
      const scopes = 'instagram_basic,instagram_manage_insights,pages_manage_metadata,pages_read_engagement,pages_show_list,business_management';

      window.location.href = `https://www.facebook.com/dialog/oauth?client_id=${appId}&redirect_uri=${redirectUri}&response_type=token&scope=${scopes}`;
    },
  },
  async created() {
    const { hash } = window.location;
    let params = null;
    if (hash.includes('access_token')) {
      params = new URLSearchParams(hash.replace('#', ''));
      await this.persistAccessToken(params.get('access_token'));
    }
    
    console.log('before loadInsightsData');
    console.log('fbAccessToken:', this.fbAccessToken);
    if (this.fbAccessToken || params) {
      await this.loadInsightsData(this.fbAccessToken || params.get('access_token'));
    }
  },
};
</script>

<style lang="scss">
.bg-settings {
  background: #e0e0e0;
}
.page-title {
  color: #7a3805;
  font-size: 22px;
  font-weight: bold;
}
.profile-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}
.metrics-card {
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
}
.tab-card {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e3e3e3;
  box-shadow: 0 2px 8px rgba(0,0,0,0.03);
  padding: 1.5rem;
}
.custom-tabs .nav-link {
  background: #f8fafc !important;
  border: 1px solid #e3e3e3 !important;
  border-bottom: none !important;
  color: #7a3805 !important;
  font-weight: 600;
  border-radius: 12px 12px 0 0 !important;
  margin-right: 4px;
}
.custom-tabs .nav-link.active {
  background: #fff !important;
  color: #d06859 !important;
  border-bottom: 2px solid #d06859 !important;
}
.custom-tab-content {
  background: #fff;
  border-radius: 0 0 12px 12px;
  border: 1px solid #e3e3e3;
  border-top: none;
  padding: 1.5rem;
}
.b-list-group-item {
  background: #f8fafc;
  border: none;
  border-bottom: 1px solid #ececec;
  font-size: 1rem;
}
.b-list-group-item:last-child {
  border-bottom: none;
}
.recent-list {
  padding-left: 1.5rem;
  font-size: 0.95rem;
  color: #444;
}
.text-pink {
  color: #e83e8c !important;
}
.alert-button-desktop {
  float: left;
  height: 26px;
  padding-top: 3px;
  font-size: 12px;
  justify-content: space-between;
  @media screen and (max-width: $md) {
    font-size: 14px;
  }
  @media screen and (max-width: $md) {
    padding-top: 6px;
    height: 34px;
  }
}
.preserve-lines {
  white-space: pre-line;
}

</style>
